import React from "react";
import UpdatedSolutionDetails from "../../components/Solutions/SolutionDetails/UpdatedSolDetails";

const UpdatedSolutionsDetail: React.FC<any> = ({ setLoading }) => {
  return (
    <div>
      <UpdatedSolutionDetails setLoading={setLoading} />
    </div>
  );
};

export default UpdatedSolutionsDetail;
